import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, AppBar, Tabs, Tab, Divider,  } from '@material-ui/core';
import { } from '@material-ui/icons';
import PropTypes from 'prop-types';
import creds from '../../config/firebaseConfig';
import db from '../../config/firestoreConfig';

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '50%',
        margingBottom: 'auto'
        },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: 20,
        width: '75%',
        margin: 'auto'
        },
        tabBar: {
            flexGrow: 1,
            width: '100%',
            backgroundColor: theme.palette.background.paper,
        },
    button: {
        margin: theme.spacing.unit,
        },
})

function TabContainer(props) {
    return (
      <Typography component="div" style={{ padding: 8 * 3 }}>
        {props.children}
      </Typography>
    );
  }

  TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
  };

class CreateContent extends Component{
    constructor(props){
        super(props)
        this.state = {
            levels: [],
            subjects: [],
            sections: [],
            tabValue: 0,
            value: 0,
        }
    }

    componentDidMount(){
        db.collection('Level').get()
            .then(snapshot => {
                snapshot.forEach( level => {
                    const subj = []
                    this.state.levels.push(level.id)
                    db.collection('Level').doc(level.id).collection('Subjects').get()
                    .then(snapshot => {
                        snapshot.forEach(subject => {
                            subj.push(subject.id)
                            // console.log(subj)
                            // console.log(subject.data().Content.Sections)
                            var obj = [level.id, subject.id, subject.data().Content.Sections ]
                            // console.log(obj)
                            this.state.sections.push(obj)
                            console.log(this.state.sections)
                        })
                        
                    })
                    this.state.subjects.push(subj)
                    console.log(this.state)
                })
            })
    }

    tabHandleChange = (event, value) => {
        this.setState({ value });
      };

    render(){
        const { classes } = this.props;
        const { value } = this.state;
        return (
             
                <Paper className={classes.container} elevation={1}>
                    <Typography variant='headline'>
                        Create Content sections
                    </Typography>
                    <Divider/>
                    <br/>
                    <br/>
                    {(this.state.sections ? 
                        <div className={classes.tabBar}>
                            <AppBar position="static">
                            <Tabs value={value} onChange={this.tabHandleChange}>
                                <Tab label="Item One" />
                                <Tab label="Item Two" />
                                <Tab label="Item Three" href="#basic-tabs" />
                            </Tabs>
                            </AppBar>
                            {value === 0 && <TabContainer>Item One</TabContainer>}
                            {value === 1 && <TabContainer>Item Two</TabContainer>}
                            {value === 2 && <TabContainer>Item Three</TabContainer>}
                        </div>
                        :  
                        <div><h1> hello</h1></div>)}
                </Paper>
        )
    }
}

CreateContent.propTypes = {
    classes: PropTypes.object.isRequired,
  };


export default withStyles(styles)(CreateContent);


// WEBPACK FOOTER //
// ./src/pages/Create/content.jsx